import { Component } from "@angular/core";

@Component({
  selector: "astrobin-migration-guidelines",
  templateUrl: "./migration-guidelines.component.html",
  styleUrls: ["./migration-guidelines.component.scss"]
})
export class MigrationGuidelinesComponent {}
